import { useEffect } from 'react';

import { useStores } from '../../../stores/useStores';
import { PocSuccessNotification } from '../PocSuccessNotification/PocSuccessNotification';

import { pocReactionDialogFactory } from './PocReactionDialog';

export function usePocReactionDialog() {
  const { pocStore } = useStores();

  useEffect(() => {
    pocStore.PocReactionComponent = pocReactionDialogFactory();
    pocStore.PocSuccessNtfComponent = PocSuccessNotification;
  }, [pocStore]);
}
